import script from "./StandardPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardPayment.vue?vue&type=script&setup=true&lang=js"

import "./StandardPayment.vue?vue&type=style&index=0&id=39eb0a98&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39eb0a98"]])

export default __exports__